import React from "react";
import PropTypes from "prop-types";

// Icons
import diamonds from "../../../assets/images/diamonds.png";
import hearts from "../../../assets/images/hearts.png";
import spades from "../../../assets/images/spades.png";
import clubs from "../../../assets/images/clubs.png";

const suitConfig = {
  diamonds: {
    icon: diamonds,
  },
  hearts: {
    icon: hearts,
  },
  spades: {
    icon: spades,
  },
  clubs: {
    icon: clubs,
  },
};

// label: optional suit name for screen readers; without it the icon is decorative.
const SuitIcon = ({ suit, size, label = null }) => {
  const iconStyle = {
    width: size,
    height: size,
    backgroundImage: `url(${suitConfig[suit].icon})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "contain",
    display: "inline-block",
  };
  const icon = <span className="suit-icon" style={iconStyle} aria-hidden="true" />;

  if (!label) {
    return icon;
  }

  return (
    <>
      {icon}
      <span className="visually-hidden">{label}</span>
    </>
  );
};

SuitIcon.propTypes = {
  suit: PropTypes.oneOf(["diamonds", "hearts", "spades", "clubs"]).isRequired,
  size: PropTypes.number.isRequired,
  label: PropTypes.string,
};

export default SuitIcon;
